<template>
    <div :class="classList">
        <div class="slider">
            <SrInputLabel class="label" :label="label" :required="required" />
            <VSlider
                :thumb-size="24"
                thumb-label="always"
                thumb-color="#fff"
                :value="value"
                :disabled="disabled"
                v-bind="$attrs"
                @change="onChange"
            />
        </div>
        <SrInput :value="value" hide-details class="input" :disabled="disabled" @input="onChange" />
    </div>
</template>

<script>
import { SrInputLabel } from '../SrInputLabel';
import { SrInput } from '../SrInput';
import { USER_INPUT_CLASS } from '../../utils/classNames';

const ELEMENT_CLASS = 'sr-slider';

export default {
    name: 'SrSlider',
    components: { SrInputLabel, SrInput },
    model: {
        prop: 'value',
        event: 'input',
    },
    props: {
        label: {
            type: String,
            required: true,
        },
        required: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        value: {
            type: [String, Number],
            required: true,
            default: 0,
        },
    },
    computed: {
        classList() {
            return [ELEMENT_CLASS, USER_INPUT_CLASS];
        },
    },
    methods: {
        onChange(value) {
            this.$emit('input', value);
        },
    },
};
</script>
